import React from 'react';
import "./Navbar.css";
const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-gray bg-blue">
      <div className="container-fluid">
      <a className="navbar-brand" href="/">
          <img src="./images/logo22.png" alt = "Omega Review Solutions Private limited"
            className="logo" />
        </a>

        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item"><a className="nav-link active" href="#home">Home</a></li>
            <li className="nav-item"><a className="nav-link" href="#services-section">Services</a></li>
            <li className="nav-item"><a className="nav-link" href="#careers-section">Careers</a></li>
            <li className="nav-item"><a className="nav-link" href="#about-section">About</a></li>
            <li className="nav-item"><a className="nav-link" href="#contact-form-section">Contact Us</a></li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
